export default "__VITE_ASSET__QZYadfya__"